import { ScriptService } from './core/services/script/script.service';
import { Component, OnInit } from '@angular/core';
import basePagesAnimation from './shared/animations/base.pages.animation';
import {
  RouterOutlet,
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
} from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['app.component.scss'],
  animations: [basePagesAnimation],
})
export class AppComponent implements OnInit {
  getDepth(outlet: RouterOutlet) {
    return outlet.activatedRouteData.depth;
  }

  constructor(
    private readonly router: Router,
    private readonly spinner: NgxSpinnerService,
    private script: ScriptService
  ) {}

  ngOnInit() {
    this.router.events.subscribe((routerEvent) => {
      this.checkRouterEvent(routerEvent);
    });
    this.script
      .load('rd')
      .then((data) => {
        console.log('script loaded ', data);
      })
      .catch((error) => console.log(error));
  }

  checkRouterEvent(routerEvent): void {
    if (routerEvent instanceof NavigationStart) {
      this.spinner.show();
    }

    if (
      routerEvent instanceof NavigationEnd ||
      routerEvent instanceof NavigationCancel ||
      routerEvent instanceof NavigationError
    ) {
      this.spinner.hide();
    }
  }
}
